export default __webpack_public_path__ + "static/sizing-chart-fae819698532f21cf35db667e28af46d.jpeg";